import type { SearchResourcesV2MutationRequestApi } from '@ingenico/api-sdk-device-management-private-v2';
import type { ArtifactSearchRequest } from '@ingenico/react-form-builder';

export function buildDataFileResourceSearchBody({
  query,
  acceptedExtensions,
}: ArtifactSearchRequest): SearchResourcesV2MutationRequestApi {
  const filters: SearchResourcesV2MutationRequestApi['filters'] = [];
  if (acceptedExtensions?.length) {
    const extensions = [
      ...new Set(acceptedExtensions.map((extension) => extension.trim().replace(/^\./, '').toLowerCase())),
    ];
    filters.push({
      filterType: 'array',
      name: 'resource.extension',
      operator: 'in',
      value: JSON.stringify(extensions),
    });
  }
  if (query) filters.push({ filterType: 'fulltext', name: '', operator: 'equals', value: query });
  return { filters, sort: { field: 'resource.name', order: 'ASC' } };
}
